import { ofType } from 'redux-observable';
import { mergeMap, debounceTime } from 'rxjs/operators';
import { merge, of } from 'rxjs';

import { GET_WATCHLIST_UPDATE_LOGS } from '../types';
import { WATCHLIST_UPDATE_LOG_MESSAGES } from '../constants/watchlistUpdateLogMessages';
import { getWatchListUpdateLogsPending, getWatchListUpdateLogsFulfilled, getWatchListUpdateLogsRejected } from '../actions';
import { sendApiRequest, notifyError, notifyWarning } from '../../../actions';
import { watchListUpdateLogsFiltersSelector } from '../selectors';
import generateError from '../../../utilities/generateError';

const createPayload = payload => ({
    method: 'get',
    url: 'report/getwatchlistupdatelogs',
    onSuccess: [response => (response.data.length === 0
        ? notifyWarning(WATCHLIST_UPDATE_LOG_MESSAGES.NOT_FOUND)
        : getWatchListUpdateLogsFulfilled(response))],
    onError: [
        getWatchListUpdateLogsRejected,
        error => notifyError(generateError(error)),
    ],
    data: payload,
});

const meta = {
    api: 'ajaxApi',
};

const getWatchListUpdateLogsEpic$ = (action$, state$) => action$.pipe(
    ofType(GET_WATCHLIST_UPDATE_LOGS.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) => {
        const filters = watchListUpdateLogsFiltersSelector(state$.value);
        return merge(
            of(getWatchListUpdateLogsPending()),
            of(sendApiRequest(createPayload({ ...payload, ...filters }), meta)),
        );
    }),
);

export default getWatchListUpdateLogsEpic$;


// WEBPACK FOOTER //
// ./src/features/reports/epics/getWatchListUpdateLogsEpic.js